import Modal from "bootstrap/js/src/modal";

const buttonsQuotationPopup = document.querySelectorAll('.js-popup-quotation a');
const quotationPopupDOM = document.querySelector('#formModalQuotation');
const quotationPopup = new Modal(quotationPopupDOM);
buttonsQuotationPopup.forEach(button => {
    button.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        gtag('event', 'click', {
            'event_category': 'Hero section',
            'event_label': window.location.pathname
        });

        quotationPopup.show();
    })
});

const buttonsPresentationPopup = document.querySelectorAll('.js-popup-presentation a');
const presentationPopupDOM = document.querySelector('#formModalPresentation');
const presentationPopup = new Modal(presentationPopupDOM);
buttonsPresentationPopup.forEach(button => {
    button.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        gtag('event', 'click', {
            'event_category': 'Hero section',
            'event_label': window.location.pathname
        });

        presentationPopup.show();
    })
});